<template>
  <div
      :class="logoStyles">
    <router-link :to="{ name: 'HomePage' }">
      <img
          src="@/assets/icons/new-ui/left-navbar/ring-logo.svg"
          :class="imgStyles">
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: {
    collapsed: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    logoStyles() {
      if (this.collapsed) {
        return "collapsed";
      }

      return "normal";
    },
    imgStyles() {
      if (this.collapsed) {
        return "size__collapsed";
      }

      return "size__normal";
    },
  },
};
</script>

<style scoped>
.normal {
  background-color: white;
  padding-top: 32px;
  padding-left: 16px;
  padding-bottom: 19px;
}

.collapsed {
  background-color: white;
  padding-top: 32px;
  /*padding-left: 16px;*/
  padding-bottom: 19px;
  display: flex;
  justify-content: center;
}

.size__normal {
  width: 64px;
}

.size__collapsed {
  width: 50px;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
